<template>
  <div
    class="w-full flex flex-col justify-between items-center
      relative lg:flex-row py-4 lg:py-2.5"
    :class="backgroundColor"
  >
    <div
      class="flex justify-start items-center gap-2.5 min-h-10 w-full lg:w-auto"
      :class="textColor"
    >
      <div
        class="w-24"
      >
        <ImgView
          :src="image"
          :alt="alt"
        />
      </div>
      <div
        v-if="imageLabel"
        class="text-base border-l pl-2.5 flex-1"
        :class="borderColor"
      >
        {{ imageLabel }}
      </div>
    </div>
    <div
      v-if="showLinkSection"
      class="flex-col justify-end items-start h-auto w-full lg:w-auto lg:items-center lg:gap-7 lg:flex-row"
      :class="linkSectionStyles"
    >
      <div class="flex items-center justify-center gap-2.5 py-2 lg:py-0 lg:gap-7 lg:justify-end lg:w-auto">
        <span
          v-if="icon"
          class="text-xl hidden lg:block"
          :class="[icon, textColor]"
        />
        <span
          v-if="iconLabel"
          :class="textColor"
        >
          {{ iconLabel }}
        </span>
      </div>
      <div v-if="linkUrl && linkText">
        <CustomLink
          :url="linkUrl"
          :type="LINK_TYPE.NoStyle"
          class="text-base font-semibold h-auto"
          :class="linkTextColor"
        >
          <span class="flex items-center">{{ linkText }}<span class="iconify svg--chevron-right text-2xl" /></span>
        </CustomLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ImgView from '~/components/atoms/ImgView/ImgView.vue';
import CustomLink from '~/components/atoms/Link/CustomLink.vue';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'StrapWithLink',
  components: {
    ImgView,
    CustomLink,
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'wide-bg-EXPONDO-primary',
    },
    textColor: {
      type: String,
      default: 'text-EXPONDO-white',
    },
    borderColor: {
      type: String,
      default: 'border-EXPONDO-white',
    },
    image: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    imageLabel: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconLabel: {
      type: String,
      default: '',
    },
    linkUrl: {
      type: String,
      default: '',
    },
    linkText: {
      type: String,
      default: '',
    },
    linkTextColor: {
      type: String,
      default: 'text-EXPONDO-secondary-medium',
    },
  },
  setup(props) {

    const showLinkSection = computed(() => {

      return props.icon || props.iconLabel || (props.linkUrl && props.linkText);
    
    });

    const linkSectionStyles = computed(() => {

      const onlyIconProvided = props.icon && !(props.iconLabel || (props.linkUrl && props.linkText));

      return onlyIconProvided ? 'hidden lg:flex' : 'flex';
    
    });

    return {
      LINK_TYPE,
      showLinkSection,
      linkSectionStyles,
    };
  
  },
});
</script>
